import {objectPatch} from '../../../../../lib/helpers';

export interface InputState {
  readonly value: string;
}

export interface InputStates {
  readonly [index: string]: InputState
}

export interface OpenEndedQuestionState {
  readonly states: InputStates;
}

/******************************************************************************/

export function setInputValue(state: OpenEndedQuestionState,
                              inputId: string,
                              value: string): OpenEndedQuestionState {
  const states = state.states;
  const newState: InputState = {value: value};
  const newStates = objectPatch(states, inputId, newState);
  return {states: newStates};
}
